import { uploadFiles } from 'src/services/apiClient';

const css = `

* {
    font-family: Tahoma;
}

html, body {
    margin: 0;
    padding: 0;
}

body {
    background: #F9F5F2;
    padding: 60px 40px;
}

main {
    display: flex;
    flex-direction: column;
    gap: 48px;
}

main section {
    background: #FFFFFF;
    border: 1px solid #C8C8C8;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;

}

main section header {
  padding-bottom: 26px;
  border-bottom: 2px solid #EFEFEF;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;

}
main section header h4 {
  color: #353744;
  font-weight: 900;
  font-size: 24px;
  line-height: 34px;
}

main section header h6 {
  color: #3D6666;
  font-weight: 800;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 5px;
}

main section article {
  display: flex;
  flex-direction: column;

}
main section article strong {
  color: #353744;
  font-weight: 900;
  font-size: 14px;
  line-height: 21px;
}

main section article span {
  color: #65666A;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: baseline;
  gap: 4px;
  
}
main section article span h6 {
  font-weight: 800;
  font-size: 14px;
  line-height: 21px;
  color: #65666A;
  margin-top: 8px;
}

strong + span {
  margin-top: 8px;
}

article + article {
  margin-top: 32px;
}

h5 {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #7B7C82;
    margin: 30px 0 24px;
}

table {
    width: fit-content;
  margin-top: -12px;
  margin-left: -18px;
  border-collapse: separate;
  border-spacing: 18px 16px;
  color: #65666A;

}
table td:first-of-type {
  font-weight: 900;
  color: #353744;
  width: fit-content;
}

div#app-list-drawer-header {
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  background-color: #fff;
  border: 1px solid #C8C8C8;
  margin-bottom: 48px;
}

div#app-list-drawer-header header {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    justify-content: space-between;
}

div#app-list-drawer-header main {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
}

div#app-list-drawer-header h4 {
    font-weight: 900;
  font-size: 24px;
  line-height: 34px;
  color: #937251;
}
div#app-list-drawer-header table {
    table-layout: fixed;
    width: 60%;
}
div#app-list-drawer-header table th {
    font-weight: 900;
    font-size: 14px;
    line-height: 19px;
    color: #7B7C82;
    text-align: left;
  }

  div#app-list-drawer-header table td {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #353744;
  }

  div#app-list-drawer-header table td, th {
    white-space: nowrap;
  }
`;

async function uploadSelector(filename: string) {
    let content = document.querySelector('#app-list-drawer-content')?.outerHTML;
    const header = document.getElementById('app-list-drawer-header')?.cloneNode(true)
    const headerDiv = document.createElement('div')
    header && headerDiv.appendChild(header)
    headerDiv.querySelector('#app-list-cta-buttons')?.remove()
    headerDiv.querySelectorAll('button').forEach(btn => btn.remove())
    content = `<html><head><style>${css}</style><title>Application</title></head><body>${headerDiv?.outerHTML}${content}</body></html>`;
    const file = new File([content], filename);
    const result = await uploadFiles([file]);
    return result;
}
export default uploadSelector;